import React from 'react';
import { Table } from 'react-bootstrap';
import { ButtonTooltip } from '../../components/Utils/Tooltips';
import DocumentPreview from '../DocumentPreview/DocumentPreview';
import Icon from '../../components/Icons';

const AttendanceDetailReportFilterDataTable = ({ attendances, totals, setDocumentModalBody, setDocumentModalShow }) => {
  const renderResult = attendance => {
    const renderObservation = observation => (
      <div dangerouslySetInnerHTML={{ __html: observation.replace(/\n/g, '<br>') }} />
    );

    const styleButtonTooltip = {
      width: 'auto',
      height: 'auto',
      borderRadius: '10%',
      display: 'initial'
    };

    return (
      <tr>
        <td className="text-center align-middle">{attendance.date_formatted}</td>
        <td className="text-center align-middle">{attendance.shift}</td>
        <td className="text-center align-middle">{attendance.attendance_day}</td>
        <td className="text-center align-middle">{attendance.shift_break}</td>
        <td className="text-center align-middle">{attendance.attendance_break}</td>
        <td className="text-center align-middle">{attendance.total_attendance_day}</td>
        <td className="text-center align-middle">{attendance.total_hours_non_worked}</td>
        <td className="text-center align-middle">{attendance.late_workday}</td>
        <td className="text-center align-middle">{attendance.early_departure}</td>
        <td className="text-center align-middle">{attendance.hours_extra}</td>
        <td className="text-center align-middle">
          <>
            {attendance?.document && (
              <ButtonTooltip
                onClick={() => {
                  setDocumentModalBody(
                    <DocumentPreview
                      documentId={attendance?.overtime_ag_document?.id}
                      employeeId={attendance?.overtime_ag_document?.employee_id}
                    />
                  );
                  setDocumentModalShow(true);
                }}
                variant="circle-info"
                className="btn-circle"
                style={styleButtonTooltip}
                toolbarVariant="justify-content-center"
                size="sm"
                text="Ver Pacto H.E"
                disabledTooltip
              >
                <Icon icon="profile" /> Ver Pacto H.E
              </ButtonTooltip>
            )}

            {attendance?.permission_document && (
              <ButtonTooltip
                onClick={() => {
                  setDocumentModalBody(
                    <DocumentPreview
                      documentId={attendance?.permission_document?.id}
                      employeeId={attendance?.permission_document?.employee_id}
                    />
                  );
                  setDocumentModalShow(true);
                }}
                variant="circle-info"
                className="btn-circle"
                style={styleButtonTooltip}
                toolbarVariant="justify-content-center"
                size="sm"
                text="Ver Permiso"
                disabledTooltip
              >
                <Icon icon="profile" /> Ver Permiso
              </ButtonTooltip>
            )}

            {attendance?.vacation_docuemnt && (
              <ButtonTooltip
                onClick={() => {
                  setDocumentModalBody(
                    <DocumentPreview
                      documentId={attendance?.vacation_docuemnt?.id}
                      employeeId={attendance?.vacation_docuemnt?.employee_id}
                    />
                  );
                  setDocumentModalShow(true);
                }}
                variant="circle-info"
                className="btn-circle"
                style={styleButtonTooltip}
                toolbarVariant="justify-content-center"
                size="sm"
                text="Ver Permiso"
                disabledTooltip
              >
                <Icon icon="profile" /> Ver Vacación
              </ButtonTooltip>
            )}

            {renderObservation(attendance.observation)}
          </>
        </td>
      </tr>
    );
  };

  const totalsStyle = {
    backgroundColor: '#e6e6e6',
    fontWeight: 'bold',
    color: 'rgb(138 142 145)'
  };

  const renderTotals = totalsData => {
    return (
      <tr style={totalsStyle}>
        <td className="text-center align-middle">TOTAL:</td>
        <td className="text-center align-middle">{totalsData.total_shift_time}</td>
        <td className="text-center align-middle">{totalsData.total_hours_worked}</td>
        <td className="text-center align-middle">{totalsData.total_shift_break_time}</td>
        <td className="text-center align-middle">{totalsData.total_attendance_break_time}</td>
        <td className="text-center align-middle">{totalsData.total_hours_worked}</td>
        <td className="text-center align-middle">{totalsData.total_hours_non_worked}</td>
        <td className="text-center align-middle">{totalsData.total_minutes_late}</td>
        <td className="text-center align-middle">{totalsData.total_minutes_early_departure}</td>
        <td className="text-center align-middle">{totalsData.total_minutes_hours_extra}</td>
        <td className="text-center align-middle" />
      </tr>
    );
  };

  const renderData = () => {
    return (
      <>
        <Table className="custom-data-table" bordered size="sm" style={{ fontWeight: 400 }}>
          <thead className="rdt_TableHeadRow" style={{ backgroundColor: '#EBEBEB', textTransform: 'uppercase' }}>
            <tr className="rdt_TableCol">
              <th className="text-center align-middle">FECHA</th>
              <th className="text-center align-middle">JORNADA PACTADA</th>
              <th className="text-center align-middle">MARCAS JORNADA</th>
              <th className="text-center align-middle">COLACION</th>
              <th className="text-center align-middle">MARCAS COLACION</th>
              <th className="text-center align-middle">HORAS TRABAJADAS</th>
              <th className="text-center align-middle">HORAS NO TRABAJADAS</th>
              <th className="text-center align-middle">ATRASOS</th>
              <th className="text-center align-middle">SALIDAS ANTICIPADAS</th>
              <th className="text-center align-middle">TIEMPO EXTRA</th>
              <th className="text-center align-middle">Comentarios</th>
            </tr>
          </thead>
          <tbody>
            {attendances &&
              attendances.map((attendance, index) => (
                <React.Fragment key={attendance.id || `attendance-${index}`}>{renderResult(attendance)}</React.Fragment>
              ))}
            {totals && renderTotals(totals)}
          </tbody>
        </Table>
      </>
    );
  };

  return <>{renderData()}</>;
};

export default AttendanceDetailReportFilterDataTable;
